/* eslint-disable no-nested-ternary */
export const getPanelBoxStyle = (active, errorActive = false) => ({
  border: `1.5px solid ${errorActive ? "#f44336" : active ? "#4caf50" : "#e0e0e0"}`,
  borderRadius: 8,
  padding: "12px 16px",
  backgroundColor: errorActive ? "#fff5f5" : active ? "#f1f8f1" : "#fafafa",
  transition: "all 0.25s ease",
})

export const getPinPanelStyle = (pinError, pinLength) => ({
  border: `1.5px solid ${pinError ? "#f44336" : pinLength >= 4 ? "#4caf50" : "#e0e0e0"}`,
  borderRadius: 8,
  padding: "12px 16px",
  backgroundColor: pinError
    ? "#fff5f5"
    : pinLength >= 4
      ? "#f1f8f1"
      : "#fafafa",
  transition: "all 0.25s ease",
})

export const getPanelIconColor = (active, errorActive = false) =>
  errorActive ? "#f44336" : active ? "#4caf50" : "#757575"

export const getPinIconColor = (pinError, pinLength) =>
  pinError ? "#f44336" : pinLength >= 4 ? "#4caf50" : "#757575"

export const getPanelCaptionColor = (active, errorActive = false) =>
  errorActive ? "#f44336" : active ? "#4caf50" : "#9e9e9e"

export const getPinCaptionColor = (pinError, pinLength) =>
  pinError ? "#f44336" : pinLength >= 4 ? "#4caf50" : "#9e9e9e"

export const getPinInputStyle = showPin => ({
  letterSpacing: showPin ? "0.15em" : "0.3em",
  fontWeight: 600,
  fontSize: "1rem",
})

export const secondaryIconBtnStyle = {
  border: "1px solid #e0e0e0",
  borderRadius: 6,
  padding: 7,
  backgroundColor: "white",
}

export const deleteBtnStyle = {
  borderColor: "#f44336",
  color: "#f44336",
  padding: "2px 10px",
  fontSize: "0.75rem",
}

export const smallActionBtnStyle = {
  fontWeight: 600,
  textTransform: "none",
  padding: "2px 10px",
  fontSize: "0.75rem",
}

export const getFloorChipStyle = value => ({
  backgroundColor: value < 0 ? "#fff3e0" : "#e3f2fd",
  color: value < 0 ? "#f57c00" : "#1976d2",
})

export const getFloorChipSmallStyle = piso => ({
  backgroundColor: piso < 0 ? "#fff3e0" : "#e3f2fd",
  color: piso < 0 ? "#f57c00" : "#1976d2",
  fontSize: "0.7rem",
  height: 20,
})

export const previewImageStyle = {
  width: 200,
  height: 200,
  objectFit: "contain",
  border: "2px dashed #ccc",
  borderRadius: 8,
  backgroundColor: "#f5f5f5",
  display: "block",
}

export const imagePlaceholderStyle = {
  width: 200,
  height: 200,
  border: "2px dashed #ccc",
  borderRadius: 8,
  backgroundColor: "#f5f5f5",
}

export const compressionPaperStyle = {
  padding: 8,
  backgroundColor: "#e8f5e8",
  border: "1px solid #4caf50",
}

export const cameraButtonStyle = {
  position: "absolute",
  bottom: -5,
  right: -5,
  backgroundColor: "white",
  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
}

export const tabStyle = {
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
}

export const dialogActionsStyle = {
  padding: "12px 24px",
  borderTop: "1px solid #e0e0e0",
}

export const submitBtnStyle = {
  textTransform: "none",
  minWidth: 180,
}

export const getImportRowStyle = estado => ({
  backgroundColor: estado === "exitoso" ? "#f1f8e9" : "#ffebee",
})

export const getImportChipStyle = estado => ({
  backgroundColor: estado === "exitoso" ? "#4caf50" : "#f44336",
  color: "white",
  fontWeight: "bold",
})

export const importSummaryPaperStyles = {
  total: { padding: 12, textAlign: "center", backgroundColor: "#e3f2fd" },
  exitoso: { padding: 12, textAlign: "center", backgroundColor: "#e8f5e8" },
  fallido: { padding: 12, textAlign: "center", backgroundColor: "#ffebee" },
  tasa: { padding: 12, textAlign: "center", backgroundColor: "#f3e5f5" },
}
